import { environment } from 'src/environments/environment';

/**
 * Routes supported by the new commercial app.
 * Use ':param' syntax for dynamic segments (e.g. '/items/:id').
 */
export const COMMERCIAL_ROUTES = [
  '/projects/sourcing',
  '/projects/procurement',
  '/suppliers',
  '/items',
  '/analytics'
] as const;

export type CommercialRoute = (typeof COMMERCIAL_ROUTES)[number];

/**
 * Maps commercial routes to their equivalent local PortalApp routes.
 * PortalApp nests sourcing/procurement under /projects/... with explicit sub-routes,
 * while other modules share the same top-level path.
 */
const LOCAL_ROUTE_MAP: Record<CommercialRoute, string> = {
  '/projects/sourcing': '/projects/sourcing/in-progress',
  '/projects/procurement': '/projects/procurement/in-progress',
  '/suppliers': '/suppliers',
  '/items': '/items',
  '/analytics': '/analytics'
};

export function isCommercialRoute(path: string): boolean {
  const urlPath = path.split('?')[0].split('#')[0];
  return COMMERCIAL_ROUTES.some(
    (route) => urlPath === route || urlPath.startsWith(route + '/')
  );
}

export function getCommercialUrl(route: CommercialRoute): string {
  if (environment.commercialUrl) {
    return `${environment.commercialUrl}${route}`;
  }
  return LOCAL_ROUTE_MAP[route];
}

export function buildCommercialRedirectUrl(path: string): string {
  if (environment.commercialUrl) {
    return `${environment.commercialUrl}${path}`;
  }
  return path;
}
